import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ['container', 'element', 'button'];

	toggle() {
		if (this.containerTarget.hasAttribute('data-group-active')) {
			this.containerTarget.removeAttribute('data-group-active');
		} else {
			this.containerTarget.setAttribute('data-group-active', true);
		}
	}

	toggleSub() {
		if (this.containerTarget.hasAttribute('data-group-active-sub')) {
			this.containerTarget.removeAttribute('data-group-active-sub');
		} else {
			this.containerTarget.setAttribute('data-group-active-sub', true);
		}
	}

	setChoice(event) {
		this.buttonTarget.innerHTML = event.currentTarget.dataset.content;

		this.toggle();
	}
}
